import dispatcher from '../dispatcher/dispatcher.js';

export function setTable(tblObj){
    dispatcher.dispatch({
        type: 'SET_TABLE',
        object: tblObj
    });
}
export function setTableName(tableName){
    dispatcher.dispatch({
        type: 'SET_TABLE_NAME',
        object: tableName
    });
}

export function createNewTable(tableName){
    dispatcher.dispatch({
        type: 'CREATE_TABLE',
        object: tableName
    });
}
export function changeToPublished(id){
    dispatcher.dispatch({
        type: 'CHANGE_PUBLISH',
        object: id
    });
}
export function setAvTables(tableObj){
    dispatcher.dispatch({
        type: 'SET_AV_TABLES',
        object: tableObj
    });
}
export function setPublishTables(tableObj){
    dispatcher.dispatch({
        type: 'SET_PUB_TABLES',
        object: tableObj
    });
}
export function loadTreeFromDb(tableId){
    dispatcher.dispatch({
        type: 'SET_TABLES_ONLINE',
        object: tableId
    });
}

export function deleteTableFromDb(tableId){
    dispatcher.dispatch({
        type: 'DELETE_TABLES_ONLINE',
        object: tableId
    });
}
export function setPublish(){
    dispatcher.dispatch({
        type: 'SET_PUBLISH'
    });
}


// WEBPACK FOOTER //
// ./src/action/tableActions.js